import React from 'react';
import { useFormikContext } from 'formik';

import PaymentTermsSearch from '@components/form/search/PaymentTermsSearch';
import SociollaErrorMessage from './SociollaErrorMessage';

// eslint-disable-next-line react/prop-types
function SociollaPaymentTermsSearch({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <PaymentTermsSearch
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaPaymentTermsSearch;
